export default `
  favorites {
    id
  }
  isFavorite(id: $id)
`;
